import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=0d4425da"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports